import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

// Connects to data-controller="destroy"
export default class extends Controller { 
  connect() {
    useClickOutside(this)
  }

  destroy() {
    this.element.remove()
  }
}
